import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import AddToBag from '../product/components/add_to_bag/AddToBag';
import ProductsSlider from '../product/components/products_slider/ProductsSlider';

import { productsActions } from '../products/actions';

document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.querySelectorAll('.react-add-to-bag-button')).forEach((element) => {
    let { product } = element.dataset;
    product = JSON.parse(product);

    window.store.dispatch(productsActions.addProducts([product]));

    createRoot(
      element,
    ).render(
      <Provider store={window.store}>
        <AddToBag
          product={product}
        />
      </Provider>,
    );
  });

  Array.from(document.querySelectorAll('.react-products-slider')).forEach((element) => {
    let { products } = element.dataset;
    products = JSON.parse(products);

    createRoot(
      element,
    ).render(
      <ProductsSlider products={products} />,
    );
  });
});
